import { render, staticRenderFns } from "./InsightsCard.vue?vue&type=template&id=1a5899fa&"
import script from "./InsightsCard.vue?vue&type=script&lang=ts&"
export * from "./InsightsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports